
<div 
	matAutocompleteOrigin 
	#origin="matAutocompleteOrigin" 
	class="autocomplete-wrapper" 
	[ngClass]="{'dark-theme': config.theme === 'dark-theme'}">
	<div 
		*ngIf="!filterConfig.font && filterConfig.type !== 'app' && !((!thumbnailSource || config.value === '__...__') && dropdownOpen)" 
		class="entity-wrapper" 
		(click)="openPanel($event)" 
		[ngClass]="{
			'image-selected': thumbnailSource,
			'dropdown-closed': !dropdownOpen,
			'conditional-select-closed': !dropdownOpen && (config.key === 'imageid_toggle' || config.key === 'imageid_mousedown' || config.key === 'imageid_mouseover')}">
		<img *ngIf="thumbnailSource && config.value !== '__...__'" class="mediaclip-image" [src]="thumbnailSource">
		<i *ngIf="(config.key === 'imageid_toggle' || config.key === 'imageid_mousedown' || config.key === 'imageid_mouseover') && !dropdownOpen && !thumbnailSource" class="fa fa-plus no-image"></i>
		<div *ngIf="config.key === 'imageid' && !dropdownOpen && !thumbnailSource" class="no-main-entity">{{ 'SELECT_IMAGE' | translate}}...</div>
		<div *ngIf="config.key === 'clipid' && !dropdownOpen && !thumbnailSource" class="no-main-entity">{{ 'SELECT_MEDIACLIP' | translate}}...</div>
		<div *ngIf="!dropdownOpen && (thumbnailSource && config.value === '__...__')" class="no-main-entity">...</div>
	</div>
	<div
		*ngIf="filterConfig.type === 'app' && !config?.value && !((!thumbnailSource || config.value === '__...__') && dropdownOpen)"
		class="entity-wrapper" 
		[ngClass]="{'dropdown-closed': !dropdownOpen}"
		(click)="openPanel($event)">
		<div class="no-main-entity">{{ 'SELECT_TEMPLATE' | translate}}...</div>
	</div>

	<input
		#inputAutoComplete
		*ngIf="dropdownOpen || filterConfig.font || (filterConfig.type === 'app' && config.value)"
		[id]="ind"
		type="text" 
		[placeholder]="config.value.indexOf('__...__') !== -1? '...' : ''" 
		matInput
		class="prop-value value-text"
		[formControl]="selectControl"
		[matAutocomplete]="auto"
		[size]="selectControl.value && selectControl.value !== 0 ? selectControl.value.length: 3"
		[matAutocompleteConnectedTo]="origin"
		(click)="$event.target.select()"
		[ngClass]="{
			'no-adjunct': filterConfig.type === 'app',
			'dropdown-open': dropdownOpen,
			'conditional-select-open': config.key === 'imageid_toggle' || config.key === 'imageid_mousedown' || config.key === 'imageid_mouseover'}"
		(keydown)="onSelectKeydown(selectControl.value, $event)">
</div>

<!-- Class on mat-autocomplete is an input that takes classes set on the host mat-autocomplete element and applies them to the panel inside the overlay container (see Material Docs > Autocomplete > API or https://github.com/angular/material2/issues/11764) -->
<mat-autocomplete
	isOpen
	class="{{config.theme}}"
	#auto="matAutocomplete" 
	(opened)="toggle(true)" 
	(closed)="toggle(false)" 
	[panelWidth]="(filterConfig.font || !thumbnailSource || config.value === '__...__') ? '160px':'190px'"
	[displayWith]="displayFn.bind(this)">

	<!-- the exception for fonts -->
	<ng-container *ngIf="filterConfig.font && !searching"> 
		<mat-option
			[ngStyle]="{
				'font-family': option.fallback? 'bb-select-' + option.originalfilename + ', ' + option.fallback : 'bb-select-' + option.originalfilename}" 
			*ngFor="let option of filteredOptions" 
			[value]="option.originalfilename" 
			(onSelectionChange)="onMatOptionSelected(option)"
		>
			<span>{{ option.originalfilename | fonts: option: assetBaseUrl }}</span>
		</mat-option>
	</ng-container>

	<ng-container *ngIf="!filterConfig.font && !searching">
		<mat-option 
			*ngFor="let option of filteredOptions" 
			[value]="option.id" 
			(onSelectionChange)="onMatOptionSelected(option)">
			<div *ngIf="filterConfig.type !== 'app'" class="img-wrapper">
					<span [innerHTML]="option | thumbnail:30:16 | async" class="option-img"></span>
			</div>
			<span>{{ option.title || option.originalfilename || option.name || 'n/a'}}</span>
		</mat-option>
	</ng-container>

	<mat-option disabled *ngIf="searching">
		<div class="searching">
			{{ 'SEARCHING' | translate }}...
		</div>
	</mat-option>

	<mat-option disabled *ngIf="filteredOptions.length === 0 && searched && !searching">
		<div class="no-results">
			{{ 'NO_RESULTS_FOUND' | translate }}
		</div>
	</mat-option>

	<div *ngIf="!filterConfig.font"
		[hidden]="(numFound < 6) || showMoreClicked"
		class="show-more"
		(click)='onShowMoreClicked()'>SHOW MORE...</div> 
	
	<!-- temporarily disabled drag/drop area -->
	<!-- <div *ngIf="filterConfig.font" class="drag-drop">{{ 'DRAG_AND_DROP_FONT' | translate }} upload</div>
	<div *ngIf="!filterConfig.font" class="drag-drop">{{ 'DRAG_AND_DROP_PHOTO' | translate }}</div> -->
</mat-autocomplete>
